import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const PrivateRoute = ({ allowedRoles }) => {
    const token = localStorage.getItem('authToken');
    const location = useLocation();
    if (token) {
        const decodedToken = jwtDecode(token);
        const audString = decodedToken.aud;
        const roleClaim = Object.keys(decodedToken).find(key => key.toLowerCase().includes("role"));
        const role = roleClaim ? decodedToken[roleClaim] : null;
        if (role === 'Staff' && (location.pathname === '/admin/category' || location.pathname === '/admin/accounts' || location.pathname === '/admin/classes' || location.pathname === '/admin/department')) {
            return <Navigate to="/admin/articles" replace />;
        }
        if (allowedRoles.includes(role) && audString === "ITCertiRegis") {
            return <Outlet />;
        }
    }

    return <Navigate to="/login" replace />;
};

export default PrivateRoute;